<div class="modal-container p-6">
  <div class="modal-top">
    <h2 *ngIf="isTelephoneBooking()" class="font-bold" mat-dialog-title>
      Ta kontakt
    </h2>
    <h2 *ngIf="!isTelephoneBooking()" class="font-bold" mat-dialog-title>
      Boka tid
    </h2>
    <div class="close-btn">
      <app-ui-icon (click)="closeDialog()" color="var(--blue-3)" name="close" size="md"></app-ui-icon>
    </div>
  </div>

  <div mat-dialog-content>
    <div *ngIf="isTelephoneBooking()">
      <p>
        För att boka tid på mottagningen behöver du ringa
        <span
          [innerHTML]="
            bookingModalData.bookingConfigurationData.bookingSettings.bookingPhoneNumber
          "
        ></span
        ><span
        *ngIf="
            bookingModalData.bookingConfigurationData.telephoneHours &&
            bookingModalData.bookingConfigurationData.telephoneHours.length > 0
          "
      >
          mellan:</span
      ><span
        *ngIf="
            !bookingModalData.bookingConfigurationData.telephoneHours ||
            bookingModalData.bookingConfigurationData.telephoneHours.length === 0
          "
      >.</span
      >
      </p>
      <div class="book-opening-hours">
        <div
          *ngFor="let openHour of bookingModalData.bookingConfigurationData.telephoneHours; trackBy: openHoursTrackBy">
          <h4 *ngIf="openHour.isCommentOnly">{{ openHour.comment }}</h4>
          <span *ngIf="!openHour.isCommentOnly">
            {{ careproviderHelper.getOpenningDays(openHour) }}:
            {{ careproviderHelper.getOpenningHours(openHour) }}
            <app-ui-icon
              #tooltip="matTooltip"
              (click)="tooltip.show()"
              *ngIf="openHour.comment && openHour.comment !== ''"
              color="var(--grey-1)" matTooltip="{{ openHour.comment }}"
              matTooltipClass="varden-tooltip"
              matTooltipPosition="above"
              name="info"
              size="sm"></app-ui-icon>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="isEmailBooking()">
      <h3 class="my-4 text-xl font-bold">Vänligen kontakta oss via e-post.</h3>
      <p>
        Efter att du skickat in dina uppgifter kommer du att bli kontaktad av
        {{ bookingModalData.bookingConfigurationData.name }}.<br>
      </p>

      <form [formGroup]="bookForm">
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width">
              <input formControlName="name" matInput placeholder="Namn">
              <mat-error *ngIf="bookForm.controls.name.hasError('required')">
                Namn <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width">
              <input
                formControlName="email"
                matInput
                placeholder="E-postadress"
              >
              <mat-error
                *ngIf="
                  bookForm.controls.email.hasError('email') &&
                  !bookForm.controls.email.hasError('required')
                "
              >
                Ange en giltig e-postadress
              </mat-error>
              <mat-error *ngIf="bookForm.controls.email.hasError('required')">
                E-postadress <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width">
              <input formControlName="tel" matInput placeholder="Telefon">
              <mat-hint>Ex 07X-XXX XX XX</mat-hint>
              <mat-error *ngIf="bookForm.controls.tel.hasError('required')">
                Telefon <strong>krävs</strong>
              </mat-error>
              <mat-error *ngIf="bookForm.controls.tel.hasError('invalidPhone')">
                Vänligen ange ett giltigt telefonnummer, ex 07X-XXX XX XX.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="doctorsAvailable" class="row">
          <div class="col">
            <p>Vem vill du ska utföra behandlingen?</p>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Välj utförare</mat-label>
              <mat-select formControlName="staffid">
                <mat-option
                  *ngFor="
                    let staffMember of bookingModalData.bookingConfigurationData.bookingSettings
                      .staffMembers; trackBy: staffMemberTrackByFn
                  "
                  [value]="staffMember.id"
                >
                  {{ staffMember.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="bookForm.controls.staffid.hasError('required')">
                Utförare <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline" class="full-width">
              <textarea
                formControlName="message"
                matInput
                placeholder="Meddelande till vårdgivaren"
              ></textarea>
              <mat-error *ngIf="bookForm.controls.message.hasError('required')">
                Meddelande till vårdgivaren <strong>krävs</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-checkbox
              color="primary"
              disableRipple
              formControlName="datapolicy"
            >
              Jag har läst och accepterar:
              <a href="/villkor" target="_blank">Allmänna villkor</a> &
              <a href="/integritetspolicy" target="_blank">Integritetspolicy</a>
            </mat-checkbox>
            <mat-error
              *ngIf="
                bookForm.controls.datapolicy.hasError('pattern') &&
                bookForm.controls.datapolicy.touched
              "
              class="privacy-accept-error"
            >
              För att skicka in din information måste du godkänna Allmänna
              villkor & Integritetspolicy.
            </mat-error>
          </div>
        </div>
      </form>
    </div>

    <div
      *ngIf="isBooking"
      [innerHTML]="bookingModalData.bookingConfigurationData.bookingSettings.bookingFormText"
    ></div>
  </div>

  <div *ngIf="isBooking" class="modal-actions" mat-dialog-actions>
    <app-ui-button
      (onClick)="saveBooking()"
      *ngIf="
          bookingModalData.bookingConfigurationData.bookingSettings.bookingType.name ===
          bookingTypeEnum.EMAIL
        "
      [color]="'secondary'"
      [compressed]="false"
      [disabled]="!(bookForm.touched && bookForm.dirty)"
      [expanded]="'inline'"
      [size]="'lg'"
    >
      Skicka
    </app-ui-button>

    <app-ui-button
      (onClick)="closeDialog()"
      [color]="'ghost'"
      [compressed]="false"
      [expanded]="'inline'"
      [size]="'lg'"
    >
      Stäng
    </app-ui-button>
  </div>
  <div
    *ngIf="!isTelephoneBooking() && bookingModalData.caregiverContactInfo && bookingModalData.caregiverContactInfo.phoneNumbers  && bookingModalData.caregiverContactInfo.phoneNumbers.length > 0"
    class="modal-actions phone-number"
    mat-dialog-actions>
    <div class="phone-number__header">Vill du ringa istället?</div>

    <app-telephone
      *ngFor="
              let phone of bookingModalData.caregiverContactInfo.phoneNumbers;
              trackBy: phoneTrackByFn
            "
      [customGa4Params]="customGa4Params"
      [label]="'email-booking-form'"
      [telephoneLabel]="phone.label"
      [telephoneNumber]="phone.number"
      class="phone-number__item"
    ></app-telephone>
  </div>
</div>
